module.exports = __webpack_public_path__ + "images/pro/events-bg-28d112b693bdf91f8b8a3270d7547f88.png";